<template>
	<div class="common-volume-library" v-loading.fullscreen.lock="loading"
		element-loading-text="拼命加载中">
		

		<div class="question-bank-h-box">
			<div class="question-bank-h-path">
				<router-link to="/test/common-library">公共卷库</router-link>
				<router-link to="/test/private-library">我的卷库</router-link>
			</div>

			<ul class="question-bank-h-type">

				<li class="question-bank-h-list">
					<span>试题类型:</span>
					<div>
						<template>
						  <el-radio-group v-model="question.type" @change="getTestList">
						  	<template v-for="item of getTestTypeList">
						  		<el-radio :label="item.id">{{item.name}}</el-radio>
						  	</template>
						  </el-radio-group>
						</template>
					</div>
				</li>

				<li class="question-bank-h-list">
					<span>题目范围:</span>
					<div>
						<template>
						  <el-select clearable  v-model="question.grade" placeholder="请选择年级" @change="setRange($event, 'grade')"> 
						    <el-option
						      v-for="(item, index) in gradeLsit"
						      :key="index"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
						  </el-select>
						</template>

						<template>
						  <el-select clearable  v-model="question.subject" placeholder="请选择科目" @change="setRange($event, 'subject')">
						    <el-option
						      v-for="(item, index) in subjectLsit"
						      :key="index"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
						  </el-select>
						</template>

						<template>
						  <el-select clearable  v-model="question.edition" placeholder="请选择版本" @change="setRange($event, 'edition')">
						    <el-option
						      v-for="(item, index) in editionList"
						      :key="index"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
						  </el-select>
						</template>

						<template>
						  <el-select clearable  v-model="question.material" placeholder="请选择教材">
						    <el-option
						      v-for="(item, index) in materialList"
						      :key="index"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
						  </el-select>
						</template>

						<el-button type="primary" @click="screenChange()">筛选</el-button>
					</div>
				</li>

			</ul>
		</div>	
		
		<div class="common-volume-library">
			
			<div class="question-bank-wp-r-h">
				<el-input
				    placeholder="搜索试卷"
				    suffix-icon="el-icon-search" 
				    v-model="question.keyword" @change="getTestList">
				  </el-input>

				  <div>
					  	<el-radio-group v-model="question.order" @change="getTestList">
					  		<el-radio label="time">最新<i class="el-icon-sort-down"></i></el-radio>
					  		<el-radio label="fav">热门<i class="el-icon-sort-down"></i></el-radio>
					  	</el-radio-group>
					</div>
			</div>

			<ul>
				<template  v-for="(item, index) of testList">
				<transition name="el-zoom-in-top">
				<li class="common-volume-ls my-common-volume" :key="index">
					<span></span>
					<div class="">
						<div class="common-volume-ls-title">
							<router-link  :to="{path: '/test/test-paper', query: {id: item.id, authority: 1}}">{{item.name}}</router-link>
							<span>更新于：{{item.update_time.substring(0, 16)}}</span>
						</div>
						<div class="common-volume-ls-tag">
							<span v-if="item.study_section">{{item.study_section}}</span>
							<span v-if="item.subject">{{item.subject}}</span>
							<span v-if="item.source">{{item.source}}</span>
							<span v-if="item.version_name">{{item.version_name}}</span>
						</div>
						<div class="common-volume-ls-op">
							<router-link :to="{path: '/test/test-paper', query: {id: item.id, authority: 1}}">预览</router-link>
							<span v-if="item.create_id != $g.user_id"  @click="operationTest(item.id)">添加到我的卷库</span>
						</div>
					</div>
				</li>
				</transition>
				</template>
			</ul>

			<div class="dependent" v-if="placeholder">
			    <i class="ipng image_state01"></i>
			    <p>还没发现任何相关的内容哦~</p>
			</div>


			<el-pagination class="test-pagination" v-show=" question.total > 10"
				@size-change="sizeChange"
				@current-change="currentChange"
				:current-page="question.page"
				:page-sizes="[10, 50, 100, 200, 300, 400]"
				:page-size="question.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="question.total">
			</el-pagination>

		</div>

	</div>
</template>

<script>
	
	export default {
		data(){
			return {
				loading: true,
				placeholder: false,
				question: {
					type: 0, 		/*试题类型*/
					grade: '', 		/*年级id*/
					subject: '',    /*科目id*/
					edition: '', 	/*版本id*/
					material: '',	/*教材*/
					order: 'time',			/*列表排序*/
					keyword: '', 			/*搜索关键字*/
					page: 1,
					size: 10,
					total: 0
				},
				gradeLsit: [], 		/*年级列表*/
				subjectLsit: [], 	/*科目列表*/
				editionList: [], 	/*版本列表*/
				materialList: [],	/*教材*/
				activeName: 'first',
				testList: [], 		/*试卷列表*/
				getTestTypeList: [],
			}
		},
		watch: {
			'$store.state.questionChange': {
				handler(val, newval){

					if (this.$route.query.subject) {
						this.question.subject = this.$route.query.subject 
					}else{
						this.question.subject = +sessionStorage.getItem('subjectID')
					}
					
					if (this.question.subject == 0) {
						this.question.subject = ''
					}
					this.getTestList()
				},
				immediate: true
			},
		},
		created(){
			this.getGrade()
			this.getSubject()
			this.getTestType()
			// this.getTestList()
		},
		methods: {
			/**
			 * 筛选
			 * @qiu_m
			 * @DateTime 2019-11-16T11:53:17+0800
			 * @return   {[type]}                 [description]
			 */
			screenChange(){
				if (this.question.grade == '' || this.question.subject == '' || this.question.edition == '' || this.question.material == '') {
					this.chapterID = [];
					this.knowledgeID = [];
				}
				this.getTestList()
			},
			/**
			 * 请求试卷列表
			 * @DateTime 2019-07-22T13:47:02+0800
			 */
			getTestList(){
				let success = ( res=>{
					this.testList = res.data.data;
					this.question.page = parseInt(res.data.page_index);
					this.question.total  = parseInt(res.data.data_sum);
					this.loading = false;
					this.testList.length != 0 ? this.placeholder = false : this.placeholder = true;
				});

				let params = {
					// user_id: this.$g.user_id,
					page_index: this.question.page,
					page_size: this.question.size,
					grade_id: this.question.grade,
					subject_id: this.question.subject ? this.question.subject :  this.$route.query.subject,
					masterial_id: this.question.material,
					keyword: this.question.keyword ,
					order: this.question.order,
					source_id: this.question.type,
					authority:  1
				};

				this.$ajax({
					url: 'api/newtest/test_list',
					method: 'get',
					params: params,
					func: {success: success}
				})
			},
			/**
			 * 请求试题类型数据
			 * @DateTime 2019-07-25T14:09:13+0800
			 * @return   {[type]}                 [description]
			 */
			getTestType(){

				let success = (res=>{
					this.getTestTypeList = res.data;
					if (this.getTestTypeList.length > 0) {
						this.getTestTypeList.unshift({id:0, name: '全部'})
					}
				});

				let params = {status: 1};

				this.$ajax({
					url: 'api/newtest/get_test_type',
					method: 'get',
					params: params,
					func: { success: success}
				})
			},
			/**
			 * 请求年级列表数据
			 * @DateTime 2019-07-22T14:45:06+0800
			 */
			getGrade(){
				let success = (res=>{
					this.gradeLsit = res.data;
				});

				let params = {
					level:3,
					// pid:0,
					direction:'balance',
				};

				this.$ajax({
					url: 'api/org/org',
					method: 'get',
					params: params,
					func: { success: success}
				})
			},
			/**
			 * 请求科目数据
			 * @DateTime 2019-07-22T14:53:30+0800
			 */
			getSubject(){
				let success = (res=>{
					this.subjectLsit = res.data
				});

				let params = {
					type:2,
					org_id: this.question.grade,
					status:1,
				};

				this.$ajax({
					url: 'api/cate/subject',
					method: 'get',
					params: params,
					func: {success: success}
				})
			},
			/**
			 * 请求科目版本
			 * @DateTime 2019-07-22T15:30:28+0800
			 */
			getEdition(){
				let success = (res=>{
					this.editionList = res.data;
				});

				let params = {
					type:2,
					org_id:this.question.grade,
					sub_id:this.question.subject,
					status:1
				};

				this.$ajax({
					url: 'api/cate/version',
					methosd: 'get',
					params: params,
					func: {success: success}
				})
			},
			/**
			 * 请求教材列表数据
			 * @DateTime 2019-07-22T15:39:04+0800
			 * @return   {[type]}                 [description]
			 */
			getMaterial(){
				let success = (res=>{
					this.materialList = res.data;
				});

				let params = {
					org_id:this.question.grade,
					sub_id:this.question.subject,
					ver_id:this.question.edition,
					status:1
				};

				this.$ajax({
					url: 'api/cate/material',
					method: 'get',
					params: params,
					func: {success: success}
				})
			},
			/**
			 * 改变题目范围
			 * @param {String} type
			 * 根据改变当前参数重置相关数据
			 */
			setRange(val, type){

				switch( type ){
					case 'grade': /*年级*/
					
						if (this.question.grade == '') {
							this.question.subject = '';
							this.question.edition = '';
							this.question.material = '';

							this.subjectLsit = [];
							this.editionList = [];
							this.materialList = [];
							this.chapterList = []

							this.getTestList()
						}else{
							this.question.subject = '';
							this.question.edition = '';
							this.question.material = '';

							this.subjectLsit = [];
							this.editionList = [];
							this.materialList = [];

							this.getSubject();
						}
						
					break;
					case 'subject': /*科目*/
						this.question.edition = '';
						this.question.material = '';

						this.editionList = [];
						this.materialList = [];
						this.getEdition();
					break;
					case 'edition': /*版本*/
						this.question.material = '';
						this.materialList = [];
						this.getMaterial();
					break;
				}
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
			sizeChange(val) {
				// console.log(`每页 ${val} 条`);
				this.question.size = val
				this.getTestList()
			},
			currentChange(val) {
				// console.log(`当前页: ${val}`);
				this.question.page = val
				this.getTestList()
			},
			
			operationTest(id){
				this.$confirm('是否添加到我的卷库？', '提示', {
					cancelButtonText: '取消',
					confirmButtonText: '确定',
					type: 'warning',
					customClass: "test-message"
				}).then(() => {
					let success = (res=>{
						this.$message.success(res.msg)
					});

					let params = {id: id};

					this.$ajax.post('api/newtest/fav_test', params, {func: {success: success}})
				}).catch(() => {});
			},
		}

	}
</script>